import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Shield, Lock, CreditCard, FileText, Zap, BookOpen } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-20 pb-16 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto text-center" data-id="element-125">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-green/10 rounded-full blur-[120px] -z-10 pointer-events-none" data-id="element-126" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} data-id="element-127">
        <span className="inline-block text-brand-green font-bold tracking-wider text-sm mb-6 uppercase" data-id="element-128">
          🏆 MODODIGITAL™
        </span>

        <h1 className="text-5xl md:text-7xl lg:text-8xl font-black tracking-tight leading-[1.1] mb-6" data-id="element-129">
          Todo tu Abdomen Plano.
          <br data-id="element-130" />
          <span className="text-brand-green" data-id="element-131">Listo. Desde Hoy.</span>
        </h1>

        <p className="max-w-3xl mx-auto text-lg md:text-xl text-gray-300 mb-12 leading-relaxed" data-id="element-132">
          <strong className="text-white" data-id="element-133">
            SUPERPACK ABDOMEN PLANO EN 15 DÍAS
          </strong>{' '}
          — El Sistema N°1 para Bajar la Panza en Argentina
          <br className="hidden md:block" data-id="element-134" />
          Sin Gimnasio · Sin Dieta Imposible · Solo 15 Minutos por Día Desde
          Casa
        </p>

        <div className="relative max-w-3xl mx-auto mb-12" data-id="element-135">
          <img src="https://cdn.magicpatterns.com/uploads/7s5DEJm4mLFaLthnamDRzo/heylloyd-image-1779903862901.png" alt="Pack de 6 libros digitales Superpack Abdomen Plano en 15 días - MODODIGITAL" className="w-full h-auto drop-shadow-2xl relative z-10" data-id="element-136" />
        </div>

        <div className="flex flex-wrap justify-center gap-4 mb-12" data-id="element-137">
          <div className="flex items-center gap-2 bg-brand-card border border-brand-green/20 px-4 py-2 rounded-full text-sm font-medium" data-id="element-138">
            <FileText className="w-4 h-4 text-brand-green" data-id="element-139" />
            <span data-id="element-140">100% PDF</span>
          </div>
          <div className="flex items-center gap-2 bg-brand-card border border-brand-green/20 px-4 py-2 rounded-full text-sm font-medium" data-id="element-141">
            <Zap className="w-4 h-4 text-brand-gold" data-id="element-142" />
            <span data-id="element-143">Acceso en 5 min</span>
          </div>
          <div className="flex items-center gap-2 bg-brand-card border border-brand-green/20 px-4 py-2 rounded-full text-sm font-medium" data-id="element-144">
            <BookOpen className="w-4 h-4 text-brand-green" data-id="element-145" />
            <span data-id="element-146">6 Tomos + 6 Bonos</span>
          </div>
        </div>

        <motion.button whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="bg-brand-green hover:bg-emerald-400 text-brand-darker font-black text-xl md:text-2xl px-8 py-5 rounded-full flex items-center justify-center gap-3 mx-auto w-full max-w-lg shadow-[0_0_40px_rgba(16,185,129,0.3)] transition-colors" data-id="element-147">
          <span className="text-red-600" data-id="element-148">🔴</span> → QUIERO MI SUPERPACK AHORA
        </motion.button>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 mt-6 text-xs md:text-sm text-gray-400" data-id="element-149">
          <div className="flex items-center gap-1.5" data-id="element-150">
            <Shield className="w-4 h-4" data-id="element-151" />
            <span data-id="element-152">Garantía 7 días</span>
          </div>
          <div className="hidden md:block text-gray-600" data-id="element-153">·</div>
          <div className="flex items-center gap-1.5" data-id="element-154">
            <Lock className="w-4 h-4" data-id="element-155" />
            <span data-id="element-156">Pago seguro</span>
          </div>
          <div className="hidden md:block text-gray-600" data-id="element-157">·</div>
          <div className="flex items-center gap-1.5" data-id="element-158">
            <CreditCard className="w-4 h-4" data-id="element-159" />
            <span data-id="element-160">Mercado Pago</span>
          </div>
        </div>
      </motion.div>
    </section>;
}